import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Timeline from '@mui/lab/Timeline';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import { Typography, useTheme } from '@mui/material';
const HTimeline = ({ options }) => {
    const theme = useTheme();
    return (_jsx(Timeline, { sx: {
            [`& .${timelineItemClasses.root}:before`]: {
                flex: 0,
                padding: 0
            },
            padding: 0,
            '&::before': { display: 'none' }
        }, children: options.map((option, index) => (_jsxs(TimelineItem, { children: [_jsxs(TimelineSeparator, { children: [_jsx(TimelineDot, { sx: {
                                position: 'relative',
                                width: 20,
                                height: 20,
                                borderRadius: '50%',
                                margin: '8.5px 0',
                                backgroundColor: (theme) => theme.palette.common.white
                            }, children: _jsx(Typography, { variant: 'caption', textAlign: 'center', fontWeight: 400, color: 'textPrimary', sx: {
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    height: '100%',
                                    width: '100%'
                                }, children: index + 1 }) }), index !== options.length - 1 && (_jsx(TimelineConnector, { sx: {
                                borderLeft: (theme) => `1px dashed ${theme.palette.divider}`,
                                height: '100%',
                                width: '1px',
                                backgroundColor: 'transparent'
                            } }))] }), _jsxs(TimelineContent, { sx: {
                        '&.MuiTimelineContent-root': {
                            overflow: 'hidden'
                        }
                    }, children: [_jsx(Typography, { variant: 'subtitle1', color: theme.palette.text.primary, fontWeight: 600, fontSize: '16px', sx: { flex: 1, minWidth: 0, mb: 1 }, children: option.step }), option.content] })] }, option.step))) }));
};
export default HTimeline;
